import { useState } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAuth from '../../hooks/useAuth';
import logo from '../../assets/logo-white.png';

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const other = i18n.language?.startsWith('en') ? 'fr' : 'en';
  return (
    <button
      className="lang-switch"
      onClick={() => i18n.changeLanguage(other)}
      title={other === 'fr' ? 'Passer en français' : 'Switch to English'}
    >
      <i className="bi bi-globe2" /> {i18n.language?.startsWith('en') ? 'EN' : 'FR'}
    </button>
  );
}

export default function Navbar() {
  const { t } = useTranslation();
  const { isAuthenticated, role, user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = () => {
    logout();
    navigate('/');
  };
  const close = () => setOpen(false);

  return (
    <nav className="nav">
      <div className="container">
        <Link to="/" className="brand" onClick={close}>
          <img src={logo} alt="Talentech RDC" className="brand-logo" />
        </Link>

        <button className="nav-burger" onClick={() => setOpen((o) => !o)} aria-label="Menu">
          <i className={`bi bi-${open ? 'x-lg' : 'list'}`} />
        </button>

        <div className={`links ${open ? 'open' : ''}`} onClick={close}>
          <NavLink to="/technicians">{t('nav.technicians')}</NavLink>
          <NavLink to="/offres-emploi">{t('nav.jobs')}</NavLink>
          <NavLink to="/service-request">{t('nav.requestService')}</NavLink>

          {!isAuthenticated && (
            <>
              <NavLink to="/register">{t('nav.becomeTechnician')}</NavLink>
              <NavLink to="/login">{t('nav.login')}</NavLink>
              <Link to="/register" className="btn sm">{t('nav.signup')}</Link>
            </>
          )}

          {role === 'CLIENT' && (
            <>
              <NavLink to="/client">{t('nav.dashboard')}</NavLink>
              <NavLink to="/client/bookings">{t('nav.myBookings')}</NavLink>
            </>
          )}
          {role === 'TECHNICIAN' && (
            <>
              <NavLink to="/technician">{t('nav.dashboard')}</NavLink>
              <NavLink to="/technician/bookings">{t('nav.jobsTech')}</NavLink>
              <NavLink to="/technician/profile">{t('nav.profile')}</NavLink>
            </>
          )}
          {role === 'APPROVER' && (
            <>
              <NavLink to="/review/bookings">{t('nav.bookingReview')}</NavLink>
              <NavLink to="/review/technicians">{t('nav.technicianReview')}</NavLink>
              <NavLink to="/review/service-requests">{t('nav.serviceRequests')}</NavLink>
              <NavLink to="/review/chat">{t('nav.chatInbox')}</NavLink>
            </>
          )}
          {role === 'ADMIN' && (
            <>
              <NavLink to="/admin">{t('nav.admin')}</NavLink>
              <NavLink to="/review/bookings">{t('nav.bookingReview')}</NavLink>
              <NavLink to="/review/technicians">{t('nav.technicianReview')}</NavLink>
              <NavLink to="/review/service-requests">{t('nav.serviceRequests')}</NavLink>
              <NavLink to="/review/chat">{t('nav.chatInbox')}</NavLink>
              <NavLink to="/admin/users">{t('nav.users')}</NavLink>
              <NavLink to="/admin/services">{t('nav.categories')}</NavLink>
            </>
          )}

          <LanguageSwitcher />

          {isAuthenticated && (
            <button className="btn ghost sm" onClick={doLogout} title={user?.email}>
              <i className="bi bi-box-arrow-right" /> {t('nav.logout')}
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}
